export const isPassword = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/
export const hasGoodLenth = /.{8,}/
export const hasLowerCase = /[a-z]/
export const hasUpperCase = /[A-Z]/
export const hasNumber = /[0-9]/
export const hasSpecialCharactere = /[#?!@$%^&*-]/

export const isPasswordValid = (password: string) => !!isPassword.test(password)
